import React, { useEffect } from 'react';
import '../App.css';
import './Services.css';
import PageSections from '../site-content/PageSections';
import { useSitePage } from '../site/useSitePage';

function ServicesPage() {
  const site = useSitePage('services');
  useEffect(() => {
    if (site.status === 'loading') return undefined;
    const hash = window.location.hash;
    if (!hash) return undefined;
    const element = document.querySelector(hash);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
    return undefined;
  }, [site.status]);
  if (site.status === 'loading') return <div className="page-hero" aria-hidden="true" />;
  return <PageSections slug="services" sections={site.status === 'ready' ? site.sections : undefined} />;
}

export default ServicesPage;
